"use client";

import { memo } from "react";

import CardLayout from "@/components/common/cardLayout";
import ErrorMessage from "@/components/common/errorMessage";

import ActivityLevelGauge from "./components/ActivityLevelGauge";
import ActivityLevelTips from "./components/ActivityLevelTips";
import Skeleton from "./components/skeleton";
import { useActivityLevel } from "./query";

const ActivityLevel = () => {
  const { data, isLoading, isError } = useActivityLevel();

  if (isLoading) {
    return (
      <CardLayout containerClassName="!mt-0">
        <Skeleton />
      </CardLayout>
    );
  }

  if (isError || !data || "error" in data) {
    return (
      <CardLayout containerClassName="!mt-0">
        <ErrorMessage text="Failed to load activity level data" />
      </CardLayout>
    );
  }

  const activityData = data as { totalScore: number };

  if (!activityData.totalScore && activityData.totalScore !== 0) {
    return (
      <CardLayout containerClassName="!mt-0">
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <p className="text-sm font-medium text-[#59566C]">
            No activity data available
          </p>
        </div>
      </CardLayout>
    );
  }

  return (
    <CardLayout
      containerClassName="!mt-0"
      className="max-h-[345px] rounded-xl border border-[rgba(232,235,240,0.5)] bg-white shadow-[0_10px_45px_0_rgba(0,0,0,0.03)]"
    >
      <div className="flex flex-col items-center">
        <ActivityLevelGauge score={activityData.totalScore} />
        <div className="my-5 h-px w-full bg-[#E8E8EB]" />
        <ActivityLevelTips />
      </div>
    </CardLayout>
  );
};

export default memo(ActivityLevel);
